import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';

// Confirmation avant de changer de semaine : propose d'enregistrer le brouillon en cours
export default function ConfirmSwitchWeekDialog({ open, saving, onCancel, onDiscard, onSaveAndSwitch }) {
    return (
        <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth PaperProps={{ style: { borderRadius: 16 } }}>
            <DialogTitle>Semaine non enregistrée</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Cette semaine n'est pas encore validée et contient des modifications. Voulez-vous les enregistrer en brouillon avant de changer de semaine ?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} disabled={saving}>Annuler</Button>
                <Button onClick={onDiscard} disabled={saving}>Ne pas enregistrer</Button>
                <Button onClick={onSaveAndSwitch} disabled={saving} color="primary" variant="contained">
                    Enregistrer le brouillon
                </Button>
            </DialogActions>
        </Dialog>
    );
}
